<template>
  <div class="voucher-tag">
    <span class="voucher-tag-wrap">
      <span class="voucher-tag-content">
        <span class="voucher-tag-code">{{ voucherCode }}</span>
        <span
          v-if="voucherAmount && Number(voucherAmount) > 0"
          class="voucher-tag-amount"
        >
          -{{ formattedAmount }}
        </span>
      </span>
      <span v-if="!readOnly" class="tag-remove-icon" @click="onRemoveTag">
        <i class="fas fa-times"></i>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    voucherCode: {
      type: String,
      default: '',
    },
    voucherAmount: {
      type: [Number, String],
      default: 0,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedAmount() {
      const n = Number(this.voucherAmount) || 0;
      return n.toLocaleString('vi-VN');
    },
  },
  methods: {
    onRemoveTag() {
      this.$emit('removeTag');
    },
  },
};
</script>
<style>
.voucher-tag {
  display: inline-block;
  background-color: rgb(53, 149, 246);
  border-radius: 5px;
  padding: 3px 6px;
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: #fff;
  line-height: 1.3;
  font-weight: 600;
}
.voucher-tag-wrap {
  display: inline-flex;
  align-items: center;
  margin-right: 5px;
}
.voucher-tag-content {
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  line-height: 1.25;
  min-width: 70px;
}
.voucher-tag-code {
  font-size: 12px;
  font-weight: 600;
  text-align: left;
}
.voucher-tag-amount {
  font-size: 11px;
  font-weight: 500;
  opacity: 0.95;
  margin-top: 2px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.tag-remove-icon {
  display: inline-block;
  cursor: pointer;
  margin-left: 7px;
}

.tag-remove-icon i {
  font-size: 14px;
  color: white !important;
  transition: color 0.2s ease-in-out;
}

.tag-remove-icon i:hover {
  color: #333 !important;
}
</style>
